import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import { createApiClient } from '../../apiClient';

type DeleteMfaDeviceParams = {
  deviceId: string;
  mfaAuthToken: string;
};

/**
 * Deletes a specific MFA device from the user's account.
 *
 * This function removes a multi-factor authentication device such as
 * a TOTP authenticator from the user's registered devices.
 *
 * @param params.deviceId - The unique identifier of the MFA device to delete.
 * @param params.mfaAuthToken - The MFA authentication token required for device deletion.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the MFA device is successfully deleted.
 */
export const deleteMfaDevice = async (
  { deviceId, mfaAuthToken }: DeleteMfaDeviceParams,
  client = getDefaultClient()
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  assertDefined(deviceId, 'deviceId is required');
  assertDefined(mfaAuthToken, 'mfaAuthToken is required');

  return apiClient.deleteMfaDevice({
    environmentId: core.environmentId,
    mfaDeviceId: deviceId,
    xMfaAuthToken: mfaAuthToken,
  });
};
